import React, { createContext, useContext } from 'react';

const DEFAULT_SETTINGS = {
  business_hours: {
    lines: [
      { label: 'Monday - Friday', value: '2:00 PM - 6:00 PM' },
      { label: 'Saturday', value: '10:00 AM - 6:00 PM' },
      { label: 'Sunday', value: 'Closed' },
    ],
  },
  wedding_popup: {
    enabled: false,
  },
  home_wedding: {
    eyebrow: 'Weddings',
    title: 'Your day, in full bloom',
    text: 'Custom wedding florals across the Finger Lakes — consultations, design, and delivery coordinated with your venue.',
    image: '/coryowner.png',
    link: '/weddings',
    linkLabel: 'Explore weddings',
  },
  wedding_page: {
    heroTitle: 'Weddings',
    heroSubtitle: 'Finger Lakes florals tailored to your day',
    intro:
      'From intimate lakeside ceremonies to full reception installs — we work with you to bring seasonal, locally grown beauty to every moment.',
    gallery: ['/coryowner.png', '/DSC_3860.JPG', '/Blush&BerryBloom.png', '/DSC_3888.JPG', '/DSC_3892.JPG'],
  },
};

const PublicSettingsContext = createContext(null);

export function PublicSettingsProvider({ children }) {
  return (
    <PublicSettingsContext.Provider value={{ settings: DEFAULT_SETTINGS, loading: false, refresh: () => {} }}>
      {children}
    </PublicSettingsContext.Provider>
  );
}

export function usePublicSettings() {
  const ctx = useContext(PublicSettingsContext);
  if (!ctx) return { settings: DEFAULT_SETTINGS, loading: false, refresh: () => {} };
  return ctx;
}
